import React from "react";
import { Helmet } from "react-helmet-async";
import Heading from "../components/common/Heading";
import Rooms from "../components/home/Rooms";
import QuickFacts from "../components/common/QuickFacts";

export default function Room() {
  return (
    <>
      <Helmet>
        <title>Rooms, Luxury Suites & Tariffs | HariKunj Resort Jodhpur</title>
        <meta
          name="description"
          content="Book luxury rooms and suites at HariKunj Resort in Jodhpur, Rajasthan. Explore tariffs for Standard Rooms, Deluxe Rooms, and Super Deluxe Heritage Suites with balcony views."
        />
        <link rel="canonical" href="https://harikunjresort.com/rooms" />
        <meta property="og:title" content="Rooms, Luxury Suites & Tariffs | HariKunj Resort Jodhpur" />
        <meta property="og:description" content="Book luxury rooms and suites at HariKunj Resort in Jodhpur, Rajasthan. Explore tariffs for Standard Rooms, Deluxe Rooms, and Super Deluxe Heritage Suites with balcony views." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://harikunjresort.com/rooms" />
        <meta property="og:image" content="https://harikunjresort.com/assets/img/image-1.webp" />
      </Helmet>

      <Heading heading="Our Rooms & Suites" title="Home" subtitle="Rooms" />

      <h1 className="visually-hidden">
        Luxury Rooms, Royal Suites &amp; Tariff Details — HariKunj Resort Jodhpur
      </h1>

      <Rooms />
      <QuickFacts pageTitle="Rooms & Tariff" />
    </>
  );
}
